import React from "react";
// import TextEditor from "../TextEditor";
import { observer, inject } from "mobx-react";
import AccordionQuestion from "./create_question/AccordionQuestion";
import Input from "blocks/Input";
import Switcher from 'blocks/Switcher';

import QuizQuestion from "./create_question/QuizQuestion";
import BigInput from "blocks/BigInput";
import FilePreview from "./create_question/FilePreview";
import { TARGET_FILE_CONTENT_TYPES, TARGET_FILE_MAX_SIZE } from "../constants";
import _ from "lodash";
import classNames from "classnames";
// import draftToHtml from "draftjs-to-html";
// import { convertToRaw } from "draft-js";
import QuillEditor from '../QuillEditor';

let Target;

@inject("organizationWorkshopCreate")
@inject("alert")
@inject("deleteModal")
@observer
export default class ModuleContent extends React.Component {
  constructor(props) {
    super(props);
    this.key = 1000;
    this.fileKey = 1000;
  }

  state = {
    showEraseWarning: false
  };

  warnUser = (idx, target) => {
    const isThereQuestions = this.props.organizationWorkshopCreate.modules[idx]
      .questions_attributes;
    if (isThereQuestions.length === 0) {
      this.props.organizationWorkshopCreate.clearQuestions_attributes(idx, target);
    } else {
      this.setState({
        showEraseWarning: !this.state.showEraseWarning
      });
      Target = target;
    }
  };

  showPrompt = (idx, answer) => {
    if (answer) {
      this.setState(
        {
          showEraseWarning: !this.state.showEraseWarning
        },
        this.props.organizationWorkshopCreate.clearQuestions_attributes(idx, Target)
        // this.props.organizationWorkshopCreate.setQuestionType(idx, Target)
      );
    } else {
      this.setState({
        showEraseWarning: !this.state.showEraseWarning
      });
    }
  };

  showQuestionBlock = target => {
    this.setState({
      whatQuestionBlock: target
    });
  };

  handleChange = data => {
    const regexp = /<img[^>]+src\s*=\s*['"]([^'"]+)['"][^>]*>/g;
    if(data.details) {
      const imgs = data.details.match(regexp);
      if(data.details === '<p><br></p>')
        return;
      if(!imgs || (imgs && imgs.length <= 3))
        this.props.organizationWorkshopCreate.handleModuleChange(data, this.props.index);
    } else {
      this.props.organizationWorkshopCreate.handleModuleChange(data, this.props.index);
    }
  }

  handleChangeIndex = e => {
    this.props.organizationWorkshopCreate.handleModuleChange(e, this.props.index);
  };

  addQuestion = () => {
    this.props.organizationWorkshopCreate.addQuestion(this.props.index, this.key++);
  };

  addFile = e => {
    let file = e.target.files[0];
    if (
      file.size > TARGET_FILE_MAX_SIZE ||
      !TARGET_FILE_CONTENT_TYPES.includes(file.type)
    ) {
      this.props.alert.error("File is too big or content type is not correct");
    } else {
      if (e.target.files && e.target.files[0]) {
        let reader = new FileReader();
        let file = e.target.files[0];
        reader.onload = e => {
          this.fileKey++;
          let newFile = _.assign({
            document: file,
            file_name: file.name,
            file_size: file.size,
            key: this.fileKey
          });
          this.props.organizationWorkshopCreate.addModuleFile(this.props.index, newFile);
        };
        reader.readAsDataURL(e.target.files[0]);
      }
    }
  };

  deleteFile = data => {
    let currentModule = this.props.organizationWorkshopCreate.modules[this.props.index];
    let fileIndex = _.findIndex(
      currentModule.attachments_attributes,
      el => el.key === data
    );
    let currentFile = currentModule.attachments_attributes[fileIndex];
    if (currentFile.id) {
      this.props.deleteModal.eventDelete({
        type: "file",
        fileTo: "module",
        fileId: currentFile.id,
        module: this.props.index,
        fileIndex: fileIndex
      });
    } else
      this.props.organizationWorkshopCreate.deleteModuleFile(this.props.index, fileIndex);
  };

  handleClose = () => {
    this.props.handleClose();
  };

  hideAccordion = e => {
    this.props.organizationWorkshopCreate.handleChangeOpenedEntity({ type: "none", id: 0 });
  };

  render() {
    const {description} = this.props;
    const EMPTY_FILE = (
      <label>
        <li className="file-item">
          <div className="file-item-inner">
            <i className="ic-upload-ico file-icon" />
            <div className="file-link">
              <p className="file-link-size">Formats allowed:</p>
              <p className="file-link-size">PDF, Word (Max size 5MB)</p>
            </div>
          </div>
          <input
            type="file"
            style={{ display: "none" }}
            onChange={this.addFile}
          />
        </li>
      </label>
    );

    let currentModule = this.props.organizationWorkshopCreate.modules[this.props.index];
    let currentErrors;
    if (this.props.organizationWorkshopCreate.modulesError.length - 1 < [this.props.index])
      currentErrors = {};
    else
      currentErrors = this.props.organizationWorkshopCreate.modulesError[this.props.index];

    let newCaption = "";
    let desc = this.props.organizationWorkshopCreate.modules[this.props.index]
      .details || description;
    if (desc && desc !== "") {
      newCaption = document.createElement("div");
      // newCaption.innerHTML = draftToHtml(
      //   convertToRaw(description.getCurrentContent())
      // ).trim();
      // newCaption = newCaption.textContent;

      newCaption.innerHTML = desc.replace(/<\/p>/gm, ' ').replace(/<(?:.|\n)*?>/gm, '');
      newCaption = newCaption.textContent;
    }

    return (
      <div className="accordion-content">
        <div className="row">
          <div className="col-12">
            <span
              className="accordion-btn btn bordered green empty module-save-btn"
              onClick={this.hideAccordion}
            >
              close
            </span>

            <div className="accordion-content-block">
              <BigInput
                name="title"
                type="text"
                index={this.props.index}
                value={
                  this.props.organizationWorkshopCreate.modules[this.props.index].title
                }
                handleChange={this.handleChange}
                placeholder="Module title"
                error={currentErrors.title}
              />
            </div>
          </div>
        </div>
        <div className='row'>
          <div className='col-12'>
            <div className="accordion-content-block">
              <p className="label">Module Display Order</p>
              <Input
                name="position_index"
                type="text"
                value={this.props.organizationWorkshopCreate.modules[this.props.index] ? this.props.organizationWorkshopCreate.modules[this.props.index].position_index : ''}
                handleChange={this.handleChangeIndex}
                hideLabel
                placeholder="Module Display Priority: Enter 1 for the module that you want to display first. 2 for the module you want to display next, and so on"
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div
            className={classNames({
              "col-12": true,
              "has-error": currentErrors.details
            })}
          >
            <p className="label">Module Description</p>
            <div className="accordion-content-block">

              <QuillEditor
                showToolbar={true}
                onChange={(data) => this.handleChange({details: data})}
                value={this.props.organizationWorkshopCreate.modules[this.props.index].details || desc}
                placeholder={'Enter text here. Note you can only upload up to three images per module.'}
              />

              {/* <TextEditor
                name="details"
                description={
                  this.props.organizationWorkshopCreate.modules[this.props.index].details
                }
                onChange={this.handleChange}
                type="module"
                id={this.props.index}
              /> */}

              <span className="text-editor-counter">
                {newCaption.length}/50000
              </span>
              <span className="error-text" style={{ color: "#e91e63" }}>
                {currentErrors.details}
              </span>
              <div className="border" />
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <p className="label">Choose Format For Trainee Responses</p>

            <div className="question-btn-wrapper">
              {this.state.showEraseWarning && (
                <div className="module-erase-container">
                  <div className="module-erase-wrapper">
                    <span>
                      Warning: This action will delete all existing questions
                      already created for this module.
                    </span>
                    <div>
                      <button
                        className="btn bordered empty green"
                        onClick={() => this.showPrompt(this.props.index, true)}
                      >
                        Confirm
                      </button>
                      <button
                        className="btn bordered empty red"
                        onClick={() => this.showPrompt()}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              )}

              <span
                className={classNames("btn blank", {
                  active:
                    this.props.organizationWorkshopCreate.modules[this.props.index]
                      .module_type === "quiz"
                })}
                onClick={() => this.warnUser(this.props.index, "quiz")}
              >
                Quiz (With True / False Responses)
              </span>
              <span>or</span>
              <span
                className={classNames("btn blank", {
                  active:
                    this.props.organizationWorkshopCreate.modules[this.props.index]
                      .module_type === "question"
                })}
                onClick={() => this.warnUser(this.props.index, "question")}
              >
                Questions (With Text Based Responses)
              </span>
              <span style={{margin: "0 8px"}}>or</span>
              <span
                className={classNames("btn blank", {
                  active:
                    this.props.organizationWorkshopCreate.modules[this.props.index]
                      .module_type === "other"
                })}
                onClick={() => this.warnUser(this.props.index, "other")}
              >
                Neither
              </span>
            </div>
          </div>
        </div>

        <div className="row">
          {this.props.organizationWorkshopCreate.modules[this.props.index].module_type ===
            "question" && (
            <div className="col-12">
              <div className="question-accordion-inner">
                {this.props.organizationWorkshopCreate.modules[
                  this.props.index
                ].questions_attributes.map(el => (
                  <AccordionQuestion
                    moduleIndex={this.props.index}
                    questionIndex={el.key}
                    key={el.key}
                  />
                ))}
              </div>

              <div className="row">
                <div className="col-12">
                  <div className="add-new-question">
                    <i className="ic-add-circle-ico" />
                    <span onClick={this.addQuestion}>ADD A QUESTION</span>
                  </div>
                </div>
              </div>
            </div>
          )}

          {this.props.organizationWorkshopCreate.modules[this.props.index].module_type ==
            "quiz" && (
            <div className="col-12">
              <div className="col-3">
                <Switcher
                  name="is_hidden"
                  value={!this.props.organizationWorkshopCreate.modules[this.props.index].is_hidden}
                  placeholder="Hide Quiz / Unhide Quiz From Attendees"
                  hideInput
                  reversed
                  handleChange={this.handleChange}
                  id={this.props.organizationWorkshopCreate.modules[this.props.index].id || this.props.index}
                />
              </div>
              <div className="question-accordion-inner">
                <QuizQuestion moduleIndex={this.props.index} />
              </div>
            </div>
          )}
        </div>

        <div className="row">
          <div className="col-12">
            <div className="accordion-content-block">
              <p className="label">Upload Up to 3 Files</p>
              <ul className="file-list editing">
                {currentModule.attachments_attributes.map(el => (
                  <FilePreview
                    el={el}
                    key={el.key}
                    deleteFile={this.deleteFile}
                  />
                ))}
                {currentModule.attachments_attributes.length >= 3 || EMPTY_FILE}
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/create_organization_workshop/create_module/ModuleContent.jsx